var map = {
	"./default/add-new.svg": 98590,
	"./default/add.svg": 2802,
	"./default/address.svg": 55264,
	"./default/alert.svg": 51490,
	"./default/all-contacts.svg": 54257,
	"./default/all-events.svg": 42320,
	"./default/all-notes.svg": 20115,
	"./default/all.svg": 60003,
	"./default/archive.svg": 20723,
	"./default/archived.svg": 51482,
	"./default/arrow-back.svg": 8950,
	"./default/arrow-down.svg": 81598,
	"./default/arrow-right.svg": 97795,
	"./default/arrow-up.svg": 82817,
	"./default/attachment.svg": 74152,
	"./default/attachments-1.svg": 86544,
	"./default/attachments.svg": 99357,
	"./default/bin.svg": 21641,
	"./default/blue-tick.svg": 716,
	"./default/briefcase.svg": 75390,
	"./default/building.svg": 96318,
	"./default/calendar-2.svg": 39251,
	"./default/calendar-circle.svg": 97563,
	"./default/calendar.svg": 53511,
	"./default/cancel.svg": 48981,
	"./default/chart.svg": 59862,
	"./default/chat.svg": 3410,
	"./default/checked.svg": 67196,
	"./default/chevron-down.svg": 90036,
	"./default/chevron-left.svg": 4335,
	"./default/chevron-right.svg": 42702,
	"./default/chevron-up.svg": 66177,
	"./default/clock-bold.svg": 73536,
	"./default/clock.svg": 25790,
	"./default/close.svg": 55007,
	"./default/completed.svg": 76350,
	"./default/confirm.svg": 46542,
	"./default/contacts.svg": 13643,
	"./default/copy.svg": 34678,
	"./default/create-2.svg": 5830,
	"./default/crown.svg": 16707,
	"./default/data.svg": 63533,
	"./default/delete-forever.svg": 73193,
	"./default/delete.svg": 67329,
	"./default/direct-inbox.svg": 87595,
	"./default/direct.svg": 94281,
	"./default/discard.svg": 92619,
	"./default/dislike.svg": 92354,
	"./default/down.svg": 96361,
	"./default/download.svg": 66854,
	"./default/draft.svg": 97726,
	"./default/edit-3.svg": 8614,
	"./default/edit.svg": 9881,
	"./default/element-3.svg": 11553,
	"./default/ellipsis.svg": 46670,
	"./default/email-read.svg": 43001,
	"./default/email-unread.svg": 76189,
	"./default/email.svg": 61126,
	"./default/emails.svg": 76382,
	"./default/error.svg": 85327,
	"./default/events.svg": 34333,
	"./default/expand.svg": 8549,
	"./default/eye.svg": 16481,
	"./default/favorites.svg": 62724,
	"./default/file-1.svg": 47694,
	"./default/file-doc.svg": 75377,
	"./default/file.svg": 24980,
	"./default/filter.svg": 47417,
	"./default/folder-1.svg": 97162,
	"./default/folder-minus.svg": 85834,
	"./default/folder-pdf.svg": 46678,
	"./default/folder.svg": 43799,
	"./default/forward-all.svg": 13707,
	"./default/forward.svg": 77561,
	"./default/gallery.svg": 60767,
	"./default/global-search.svg": 3371,
	"./default/global.svg": 56404,
	"./default/go-back.svg": 19616,
	"./default/import.svg": 36264,
	"./default/important-bold.svg": 29743,
	"./default/important-star.svg": 791,
	"./default/important.svg": 8466,
	"./default/inbox.svg": 22294,
	"./default/info.svg": 70467,
	"./default/initial-download.svg": 51508,
	"./default/lamp-charge.svg": 74054,
	"./default/leftright.svg": 76330,
	"./default/like.svg": 42673,
	"./default/link-connection.svg": 19358,
	"./default/link.svg": 39530,
	"./default/link1.svg": 87076,
	"./default/list.svg": 54801,
	"./default/local.svg": 99243,
	"./default/location.svg": 9339,
	"./default/logout.svg": 10909,
	"./default/manage-account.svg": 64486,
	"./default/menu-contacts.svg": 88469,
	"./default/menu-email.svg": 74910,
	"./default/menu-events.svg": 70628,
	"./default/menu-files.svg": 94870,
	"./default/menu-home.svg": 30335,
	"./default/menu-notes.svg": 59699,
	"./default/menu-task.svg": 45295,
	"./default/menu.svg": 35171,
	"./default/message-text.svg": 37985,
	"./default/message.svg": 49478,
	"./default/messages-3.svg": 70094,
	"./default/microphone.svg": 57814,
	"./default/minimize.svg": 93369,
	"./default/minus.svg": 23191,
	"./default/more-2.svg": 37981,
	"./default/more-down.svg": 67897,
	"./default/more-horizontal.svg": 48856,
	"./default/more-up.svg": 44805,
	"./default/more-vertical.svg": 72793,
	"./default/more.svg": 23928,
	"./default/movetoinbox.svg": 45825,
	"./default/no-entry.svg": 49646,
	"./default/no-waiting.svg": 9083,
	"./default/not-important.svg": 33066,
	"./default/not-preset.svg": 67770,
	"./default/note-checklist.svg": 67192,
	"./default/note-format.svg": 73943,
	"./default/note-table.svg": 74227,
	"./default/notes.svg": 30270,
	"./default/notification-bing.svg": 79702,
	"./default/notification-off.svg": 88253,
	"./default/notification.svg": 57451,
	"./default/open-view.svg": 22733,
	"./default/overdue.svg": 86723,
	"./default/paperclip.svg": 72926,
	"./default/past.svg": 39108,
	"./default/pen.svg": 39262,
	"./default/phone.svg": 14663,
	"./default/preset.svg": 18605,
	"./default/profile-add.svg": 23310,
	"./default/pull-down.svg": 3240,
	"./default/pull-up.svg": 13031,
	"./default/radar-2.svg": 97647,
	"./default/receipt-2.svg": 23287,
	"./default/receipt-text.svg": 64694,
	"./default/recurring.svg": 25174,
	"./default/refresh.svg": 23495,
	"./default/reminder.svg": 22241,
	"./default/repeat.svg": 2535,
	"./default/reply-all.svg": 12059,
	"./default/reply.svg": 48191,
	"./default/research-pack.svg": 41773,
	"./default/restore.svg": 5305,
	"./default/save-add.svg": 40325,
	"./default/search.svg": 68016,
	"./default/send-as-new.svg": 21889,
	"./default/send.svg": 69601,
	"./default/sent.svg": 44826,
	"./default/settings.svg": 21731,
	"./default/seven-days.svg": 49802,
	"./default/sidepanel.svg": 44102,
	"./default/slider-vertical.svg": 32728,
	"./default/sms-notification.svg": 39669,
	"./default/sms-star.svg": 774,
	"./default/sms-tracking.svg": 59097,
	"./default/sms.svg": 32834,
	"./default/someday.svg": 6177,
	"./default/spam.svg": 75411,
	"./default/spark.svg": 553,
	"./default/star-bold.svg": 38594,
	"./default/star-outline.svg": 84804,
	"./default/star.svg": 42239,
	"./default/story.svg": 26509,
	"./default/task-square.svg": 73648,
	"./default/tasks.svg": 21214,
	"./default/text-bold.svg": 27077,
	"./default/text-italic.svg": 90827,
	"./default/text-underline.svg": 71986,
	"./default/text.svg": 89887,
	"./default/thirty-days.svg": 51106,
	"./default/tick-circle.svg": 230,
	"./default/tick-square-bold.svg": 83570,
	"./default/tick-square.svg": 85463,
	"./default/timeline-item-note.svg": 92155,
	"./default/timeline-item-task.svg": 56850,
	"./default/today.svg": 59631,
	"./default/trash.svg": 61884,
	"./default/type-file.svg": 82767,
	"./default/unchecked.svg": 75500,
	"./default/up.svg": 66175,
	"./default/user.svg": 38242,
	"./default/waiting-on.svg": 44450,
	"./default/waitingOn.svg": 59375,
	"./default/warning.svg": 34126,
	"./default/x-mark.svg": 87039,
	"./material/archive.svg": 7870,
	"./material/delete.svg": 69536,
	"./material/email.svg": 59124,
	"./material/forward.svg": 99802,
	"./material/inbox.svg": 79591,
	"./material/notification.svg": 13997,
	"./material/reply.svg": 47223,
	"./material/search.svg": 94713,
	"./material/send.svg": 87615,
	"./material/today.svg": 45923,
	"./old/add-new.svg": 50708,
	"./old/address.svg": 80539,
	"./old/alert.svg": 75539,
	"./old/all-contacts.svg": 25754,
	"./old/all-events.svg": 15361,
	"./old/all-notes.svg": 12829,
	"./old/all.svg": 69401,
	"./old/archive.svg": 41934,
	"./old/archived.svg": 79236,
	"./old/arrow-down.svg": 59440,
	"./old/arrow-right.svg": 45918,
	"./old/arrow-up.svg": 40561,
	"./old/attachment.svg": 52065,
	"./old/attachments-1.svg": 18511,
	"./old/attachments.svg": 16202,
	"./old/bin.svg": 47305,
	"./old/black-hole.svg": 28422,
	"./old/blue-tick.svg": 93851,
	"./old/calendar.svg": 96038,
	"./old/cancel.svg": 18659,
	"./old/chart.svg": 98620,
	"./old/chat.svg": 37951,
	"./old/checked.svg": 84969,
	"./old/completed.svg": 21668,
	"./old/confirm.svg": 70893,
	"./old/contacts.svg": 69520,
	"./old/copy.svg": 59457,
	"./old/delete-forever.svg": 99977,
	"./old/delete.svg": 36466,
	"./old/discard.svg": 46967,
	"./old/down.svg": 97316,
	"./old/download.svg": 92792,
	"./old/draft.svg": 16213,
	"./old/dropbox.svg": 82237,
	"./old/ellipsis.svg": 74642,
	"./old/email-read.svg": 81019,
	"./old/email-unread.svg": 47788,
	"./old/email.svg": 26122,
	"./old/emails.svg": 54784,
	"./old/error.svg": 60625,
	"./old/events.svg": 68770,
	"./old/expand.svg": 3242,
	"./old/favorites.svg": 93368,
	"./old/file-1.svg": 91921,
	"./old/file.svg": 61911,
	"./old/folder-1.svg": 10669,
	"./old/folder.svg": 19047,
	"./old/forward-all.svg": 48742,
	"./old/forward.svg": 62461,
	"./old/go-back.svg": 1305,
	"./old/google-drive.svg": 99698,
	"./old/important.svg": 39700,
	"./old/inbox.svg": 27797,
	"./old/info.svg": 48588,
	"./old/initial-download.svg": 27283,
	"./old/leftright.svg": 99991,
	"./old/link.svg": 71766,
	"./old/link1.svg": 529,
	"./old/list.svg": 45677,
	"./old/local.svg": 50362,
	"./old/logout.svg": 28792,
	"./old/manage-account.svg": 17326,
	"./old/menu-contacts.svg": 12877,
	"./old/menu-email.svg": 87862,
	"./old/menu-events.svg": 78865,
	"./old/menu-files.svg": 74595,
	"./old/menu-notes.svg": 73835,
	"./old/menu-task.svg": 91914,
	"./old/minimize.svg": 22525,
	"./old/minus.svg": 9801,
	"./old/more-down.svg": 47025,
	"./old/more-up.svg": 89411,
	"./old/movetoinbox.svg": 25422,
	"./old/no-entry.svg": 94267,
	"./old/no-waiting.svg": 84396,
	"./old/not-important.svg": 84542,
	"./old/not-preset.svg": 85982,
	"./old/notes.svg": 32566,
	"./old/notification-off.svg": 37231,
	"./old/notification.svg": 92483,
	"./old/one-drive.svg": 22650,
	"./old/open-view.svg": 52966,
	"./old/overdue.svg": 78387,
	"./old/past.svg": 50727,
	"./old/pen.svg": 95814,
	"./old/phone.svg": 5020,
	"./old/preset.svg": 89269,
	"./old/print.svg": 32867,
	"./old/pull-down.svg": 66021,
	"./old/pull-up.svg": 18722,
	"./old/reaction.svg": 86772,
	"./old/recurring.svg": 26151,
	"./old/refresh.svg": 21972,
	"./old/reminder.svg": 69203,
	"./old/reply-all.svg": 59732,
	"./old/reply.svg": 14402,
	"./old/restore.svg": 58893,
	"./old/search.svg": 36983,
	"./old/send-as-new.svg": 63578,
	"./old/send.svg": 24386,
	"./old/sent.svg": 71820,
	"./old/settings.svg": 56508,
	"./old/seven-days.svg": 5385,
	"./old/sidepanel.svg": 20243,
	"./old/someday.svg": 10974,
	"./old/spam.svg": 68702,
	"./old/tasks.svg": 83117,
	"./old/thirty-days.svg": 83383,
	"./old/timeline-item-note.svg": 69594,
	"./old/timeline-item-task.svg": 10101,
	"./old/today.svg": 61743,
	"./old/unchecked.svg": 66832,
	"./old/unlink.svg": 22238,
	"./old/up.svg": 71320,
	"./old/user.svg": 31309,
	"./old/waiting-on.svg": 38048,
	"./old/waitingOn.svg": 69400,
	"./old/warning.svg": 9780,
	"./old/x-mark.svg": 5452
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44333;